module.exports = __webpack_public_path__ + "static/media/KMH_5138.ddf6b765.jpg";